import { Col, Divider, Layout, Row, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import { Mail, MapPin, PhoneCall } from 'lucide-react';
import Branding from '../../ui/Branding';
const { Footer: AntFooter } = Layout;

const Footer = () => {
    return (
        <AntFooter className="app-footer">
            <div className="container">
                <Row gutter={12}>
                    <Col xs={24} md={12} lg={8}>
                        <Branding logo="https://d35jitumpuemmk.cloudfront.net/assets/Magna_prefectos-logo.png" />
                        <Space size="small" direction="vertical" className="my-4">
                            <Space size="middle" align="center">
                                <Mail strokeWidth={2} size={22} color="gray" />
                                <Typography.Link href="mailto:info@magnafoodservice.co.uk">
                                    info@magnafoodservice.co.uk
                                </Typography.Link>
                            </Space>
                            <Space size="middle" align="center">
                                <PhoneCall strokeWidth={2} size={22} color="gray" />
                                <Typography.Link href="tell:+44 (0)20 8050 1231">
                                    +44 (0)20 8050 1231
                                </Typography.Link>
                            </Space>
                            <Space size="middle" align="center">
                                <MapPin strokeWidth={2} size={22} color="gray" />
                                <Typography.Text>
                                    Unit 19-21 Phoenix Distribution Park, Phoenix Way, Heston, London, TW5 9NB,
                                    United Kingdom
                                </Typography.Text>
                            </Space>
                        </Space>
                    </Col>
                </Row>
                <Divider />
                <div className="copyright text-center">
                    <Typography.Text type="secondary">
                        &copy; {dayjs().year()} Magna Foodservice Powered By Prefectos. All rights reserved.
                    </Typography.Text>
                </div>
            </div>
        </AntFooter>)
}

export default Footer